"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ArticlePagination.default;
  }
});

var _ArticlePagination = _interopRequireDefault(require("./ArticlePagination"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }